import React from 'react'
import { Link } from "react-router-dom";


const Gallery = () => {
    return (
        <>


            <div className="page-header">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12">
                            <div className="page-header-box">
                                <h1 className="text-anime-style-3" data-cursor="-opaque" style={{ perspective: 400 }}>
                                    <div className="split-line" style={{ display: 'block', textAlign: 'center', position: 'relative' }}>
                                        Our Gallery
                                    </div>
                                </h1>
                                <nav className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/">home</Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">Our Gallery</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="our-blog">
                <div className="container">
                    <div className="row section-row align-items-center">
                        <div className="col-lg-12" style={{ textAlign: "center" }}>
                            {/* Section Title Start */}
                            <div className="section-title">
                                <h3 className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>Our Blogs</h3>
                                <h2 className="text-anime-style-3" data-cursor="-opaque" style={{ perspective: 400 }}>
                                    <div className="split-line" style={{ display: 'block', textAlign: "center", position: 'relative' }}>
                                        Our Gallery
                                    </div>
                                </h2>
                            </div>
                            {/* Section Title End */}
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            {/* Post Item Start */}
                            <div className="post-item wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                {/* Post Featured Image Start*/}
                                <div className="post-featured-image">
                                    <a href="blog-single.html" data-cursor-text="View">
                                        <figure className="image-anime">
                                            <img src="assets/img/g1.jpeg" alt />
                                        </figure>
                                    </a>
                                </div>
                            </div>
                            {/* Post Item End */}
                        </div>
                        {/* <div className="col-lg-4 col-md-6">
                            <div className="post-item wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                                <div className="post-featured-image">
                                    <a href="blog-single.html" data-cursor-text="View">
                                        <figure className="image-anime">
                                            <img src="assets/img/g2.jpeg" alt />
                                        </figure>
                                    </a>
                                </div>
                               
                            </div>
                        </div> */}
                        <div className="col-lg-4 col-md-6">
                            {/* Post Item Start */}
                            <div className="post-item wow fadeInUp" data-wow-delay="0.4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                                {/* Post Featured Image Start*/}
                                <div className="post-featured-image">
                                    <a href="blog-single.html" data-cursor-text="View">
                                        <figure className="image-anime">
                                            <img src="assets/img/About us_2.png" alt />
                                        </figure>
                                    </a>
                                </div>
                            </div>
                            {/* Post Item End */}
                        </div>
                    </div>
                </div>
            </div>



        </>
    )
}

export default Gallery